import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { SortByShape } from '../../../hooks/use-sort-data'
import { SortDirection } from '../../../types'
import { LINK_COLUMN_NAME } from '../constants/common'
import { OptionsQuery, OptionsSubpage } from '../types'
import { OptionsParsedQuery, orderToString } from '../utils/query'

export function useOptionsSortChange<SortColumnType extends { id: string }>(
  subpage: OptionsSubpage,
  query: OptionsParsedQuery
) {
  const navigate = useNavigate()
  return React.useCallback(
    (
      column: SortColumnType,
      sort: SortByShape<SortColumnType>,
      changeSort: (newSort: SortColumnType, direction?: SortDirection) => void,
      prefix: string = '',
      isLinkColumn: boolean = false
    ) => {
      const newQuery = new URLSearchParams(query.params)
      const urlColumnId = isLinkColumn ? LINK_COLUMN_NAME : column.id
      const urlOrderValue =
        sort.column.id === column.id && sort.direction === SortDirection.Ascending
          ? `-${prefix}${urlColumnId}`
          : `${prefix}${urlColumnId}`

      const newOrder = { ...query.order, [subpage]: urlOrderValue }

      newQuery.set(OptionsQuery.Order, orderToString(newOrder))
      changeSort(column)
      navigate(`?${newQuery}`, { preventScrollReset: true })
    },
    [navigate, query.order, query.params, subpage]
  )
}
